import { useQuery } from 'react-query';
import * as SettingApis from 'apis/setting';
import { AxiosError } from 'axios';

export type ICompany = SettingApis.FetchProfileResponse['company'];
export type IEmployee = SettingApis.FetchProfileResponse['employee'];
export type IEmployeeWallet =
  SettingApis.FetchProfileResponse['employee']['employee_wallets'][0];
export type ICompanyWalletConfiguration =
  SettingApis.FetchProfileResponse['company']['company_wallet_configurations'][0];
export type IEmployeeSettings =
  SettingApis.FetchProfileResponse['employee']['settings'];
export type IWalletType =
  SettingApis.FetchProfileResponse['employee']['employee_wallets'][0]['wallet_type'];
export type ICompanyLocation =
  SettingApis.FetchProfileResponse['company']['settings']['location'][0];
export type ICategory =
  SettingApis.FetchProfileResponse['employee']['employee_wallets'][0]['company_wallet_configuration']['categories'][0];
export type WalletRenewFrequency = SettingApis.WalletRenewFrequency;

const getProfile = async () => {
  const {
    data: { company, employee },
  } = await SettingApis.fetchProfile();
  return { company, employee };
};

const getProfileV3 = async () => {
  // In /v3/settings/profile, we returns posttax & pretax accounts that
  // including inactive accounts too.
  const {
    data: { company, employee },
  } = await SettingApis.fetchProfileV3();

  return { company, employee };
};

const useQueryProfile = ({
  isEnabled,
  use_v3_profile = false,
  onSuccess,
  onError,
}: {
  isEnabled: boolean;
  use_v3_profile?: boolean;
  onSuccess?: (payload: { employee: IEmployee; company: ICompany }) => void;
  onError?: (e: AxiosError) => void;
}) => {
  const { data, isLoading, refetch } = useQuery(
    ['getProfile', use_v3_profile],
    () => (use_v3_profile ? getProfileV3() : getProfile()),
    {
      enabled: isEnabled,
      onSuccess,
      onError,
    }
  );

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useQueryProfile;
